import { Reveal, Eyebrow } from "./Reveal";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1601993957728-1e56ab70c5a8?q=80&auto=format&fit=crop&w=1400";

const About = () => (
  <section id="about" className="relative overflow-hidden bg-mint py-24 text-ink lg:py-32">
    <div className="mx-auto grid max-w-[88rem] grid-cols-1 items-center gap-14 px-6 md:grid-cols-12 lg:gap-20 lg:px-12">
      <Reveal className="relative md:col-span-5">
        <div className="absolute -inset-3 rounded-3xl border border-ink/15" aria-hidden="true" />
        <div className="relative overflow-hidden rounded-2xl" data-testid="about-image">
          <img
            src="/tory.png"
            alt="Tory Pizzolato, mortgage broker in Sydney and principal of Toro Finance"
            loading="lazy"
            className="h-[440px] w-full object-cover sm:h-[540px]"
          />
        </div>
        <div className="relative mt-4 rounded-xl border border-ink/10 bg-cream px-6 py-4 shadow-[0_16px_40px_-24px_rgba(52,59,65,0.35)]" data-testid="about-credential-chip">
          <p className="text-center font-mono text-[10px] uppercase tracking-[0.24em] text-eucalyptus">
            Authorised Credit Representative 554728
          </p>
        </div>
      </Reveal>

      <div className="md:col-span-7 md:pl-4">
        <Reveal>
          <Eyebrow>Who you&rsquo;re working with</Eyebrow>
          <h2 className="mt-4 font-display text-4xl font-medium leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
            Professional mortgage brokers,
            <span className="italic text-eucalyptus"> ready to help you.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.12}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-ink/70 sm:text-lg">
            Toro Finance helps clients across Sydney and NSW — whatever their
            situation. Led by Tory Pizzolato, a finance professional with 15
            years in the industry, we handle the lending — and look for ways
            to pay your home loan off sooner — while you stay in control of
            the decision.
          </p>
        </Reveal>

        <Reveal delay={0.2}>
          <blockquote className="mt-10 border-l-2 border-eucalyptus pl-7">
            <p className="font-display text-2xl font-medium italic leading-snug text-ink sm:text-3xl">
              &ldquo;Our aim is to find you a loan that not only meets your
              requirements, but exceeds your expectations in terms of rate,
              product and service.&rdquo;
            </p>
            <footer className="mt-5 font-mono text-[11px] uppercase tracking-[0.24em] text-ink/55">
              Tory Pizzolato — Principal, Toro Finance
            </footer>
          </blockquote>
        </Reveal>

        <Reveal delay={0.28}>
          <div className="mt-10 flex flex-wrap items-center gap-3" data-testid="about-credentials">
            <span
              data-testid="fbaa-badge"
              className="inline-flex items-center gap-3 rounded-full border border-eucalyptus/40 bg-cream px-5 py-2.5"
            >
              <span className="font-display text-2xl font-semibold tracking-[0.06em] text-eucalyptus">
                FBAA
              </span>
              <span className="h-6 w-px bg-ink/20" aria-hidden="true" />
              <span className="font-mono text-[9px] uppercase leading-relaxed tracking-[0.18em] text-ink/60">
                Member
                <br />
                Finance Brokers Assoc. of Australia
              </span>
            </span>
            {["Australian Credit Licence 389328", "ABN 59 673 013 646", "Aggregated through Connective"].map((c) => (
              <span
                key={c}
                className="rounded-full border border-ink/15 bg-cream/60 px-5 py-2.5 font-mono text-[10px] uppercase tracking-[0.2em] text-ink/60"
              >
                {c}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default About;
